import * as angular from "angular";

angular.module("rhSidePane", []);
